function initContactToBuy() {
  if (!window.theme || !window.subscribe) {
    setTimeout(initContactToBuy, 100);
    return;
  }
  
  const popup = document.querySelector('popup-component:has(.contact-to-buy-button)');
  if (!popup) return;
  
  const buttonActive = popup.querySelector('.contact-to-buy__btn--active');
  const buttonSoldout = popup.querySelector('.contact-to-buy__btn--soldout');
  const form = popup.querySelector('[data-contact-form]');
  const drawer = popup.querySelector('.drawer');
  
  if (!buttonActive || !buttonSoldout || !form || !drawer) return;
  
  window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, (payload) => {
    const variant = payload.data.variant;
    const variantInput = form.querySelector('[data-variant-input]');
    const variantTitle = drawer.querySelector('[data-variant-title]');
    
    if (variantInput) {
      variantInput.value = variant.id;
    }
    
    if (variantTitle) {
      variantTitle.textContent = variant.option1 || variant.title;
    }
    
    if (variant.available) {
      buttonActive.style.display = '';
      buttonSoldout.style.display = 'none';
    } else {
      buttonActive.style.display = 'none';
      buttonSoldout.style.display = '';
    }
  });
  
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    
    const formData = new FormData(form);
    const submitButton = form.querySelector('#ContactToBuySendButton');
    
    submitButton.disabled = true;
    
    try {
      const response = await fetch('https://purchase-request.savannahs.app/request', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          referrer: formData.get('referrer'),
          email: formData.get('email'),
          variantId: formData.get('variant-id')
        })
      });
      
      if (response.ok) {
        const heading = drawer.querySelector('.drawer__heading');
        const content = drawer.querySelector('.product__popup__content');
        
        if (heading) heading.textContent = 'Request sent for approval!';
        if (content) {
          content.innerHTML = `
            <div style="padding: 20px; text-align: center;">
              <p>Thank you. Your request is being reviewed by our Customer Service Team who will get back to you shortly.</p>
            </div>
          `;
        }
      } else {
        throw new Error('Request failed');
      }
    } catch (error) {
      const heading = drawer.querySelector('.drawer__heading');
      const content = drawer.querySelector('.product__popup__content');
      
      if (heading) heading.textContent = 'Oops!';
      if (content) {
        content.innerHTML = `
          <div style="padding: 20px; text-align: center;">
            <p>Something went wrong. Please contact info@savannahs.com</p>
          </div>
        `;
      }
    } finally {
      submitButton.disabled = false;
    }
  });
}

initContactToBuy();